export const FORMULA_PREVIEW_KEY = 'formula-preview';
export const RULE_PREVIEW_KEY = 'rule-preview';
